import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store';
import Cookie from 'js-cookie';
import { ElMessage } from 'element-plus';

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: {
      skipAuth: true
    },
    component: () => import(/* webpackChunkName: "Login" */ '@/views/Login/Login.vue')
  },
  {
    path: '/home',
    name: 'ManagePage',
    children: [],
    component: () =>
      import(/* webpackChunkName: "ManagePage" */ '@/views/ManagePage/ManagePage.vue')
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/login'
  // }
];

const router = createRouter({
  history: createWebHashHistory('/sys/'),
  routes
});
const { push, replace } = router;

// 劫持router 内置方法 添加逻辑
router.push = function (to, isKeepAlive = false) {
  console.log(to, isKeepAlive)
  const type = isKeepAlive ? 'add' : 'delete';
  if (typeof to === 'string') {
    to = { name: to };
  }
  if (!this.hasRoute(to.name)) {
    // 如果没有注册过该路由
    console.error(`route为 '${to.name}' 的路由不存在不存在, 请检查跳转name是否正确`);
    return push.call(this, to);
  }

  store.commit('router/updateKeepAlive', { routes: this.currentRoute.value.name, type });
  store.commit('router/updateTabsList', { tab: to, type: 'add' });
  return push.call(this, to);
};

router.replace = function (to, isKeepAlive = false) {
  const type = isKeepAlive ? 'add' : 'delete';

  if (typeof to === 'string') {
    to = { name: to };
  }
  if (!this.hasRoute(to.name)) {
    // 如果没有注册过该路由
    console.error(`route为: '${to.name}' 的路由不存在不存在, 请检查跳转name是否正确`);
    return push.call(this, to);
  }

  store.commit('router/updateKeepAlive', { routes: this.currentRoute.value.name, type });
  store.commit('router/updateTabsList', { tab: to, type: 'add' });
  return replace.call(this, to);
};

router.beforeEach((to, from, next) => {
  if (!Cookie.get('userInfo') && !to.meta?.skipAuth) {
    // 需要授信 且未登录页面
    next({ name: 'Login' });
    ElMessage.warning('请先登录后再进行操作!');
    return;
  }
  next();
});

export default router;
